// extracted by mini-css-extract-plugin
export default {"smart":"CryptoGPTView_smart__wC9tJ","howItWorks":"CryptoGPTView_howItWorks__ZMDTe"};